import {PlainLink} from 'core/components/link'
import {IFormFields, Register, registerFormFactory} from 'core/components/register'
import {routeProps} from 'core/utils/react-router-helpers'
import * as React from 'react'
import {connect, Dispatch} from 'react-redux'
import {Redirect, RouteComponentProps, withRouter} from 'react-router'
import Card from 'study_reviewer/components/Card'
import * as routes from 'study_reviewer/routes'
import {IState, registerRequest} from 'study_reviewer/store'
import * as styles from './LoginPage.css'

interface IStateProps {
  isLoggedIn: boolean
}
interface IDispatchProps {
}
interface IOwnProps extends RouteComponentProps<void> {}
interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

const REGISTER_FORM_NAME = 'register'
const onSubmit = (data: IFormFields, dispatch: Dispatch<void>) => {
  dispatch(registerRequest(data, REGISTER_FORM_NAME))
}
const RegisterForm = registerFormFactory({formName: REGISTER_FORM_NAME, onSubmit})

class RegisterPageView extends React.Component<IProps, {}> {
  public render() {
    const {isLoggedIn} = this.props
    if (isLoggedIn) return this.redirectToReferrer()

    return (
      <div className={styles.page}>
        <Card>
          <Register
            {...routeProps<IProps, void>(this.props)}
            renderForm={() => <RegisterForm theme={{error: styles.error}} />}
            theme={{graphic: styles.graphic, lettering: styles.lettering}}
          />
        </Card>
        <Card>
          <PlainLink className={styles.link} to={routes.loginRoute()}>Already have an account? <u>Login</u></PlainLink>
        </Card>
      </div>
    )
  }

  private redirectToReferrer() {
    const from = this.props.location.state && this.props.location.state.from
    if (!from || from.pathname === routes.loginRoute() || from.pathname === routes.logoutRoute()) {
      return <Redirect to={routes.loginRoute()} />
    }
    return <Redirect to={from} />
  }
}

const mapStateToProps = (state: IState): IStateProps => ({
  isLoggedIn: !!state.login.token,
})

export default withRouter(
  connect<IStateProps, IDispatchProps, IOwnProps, IState>(mapStateToProps)(RegisterPageView),
)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/pages/RegisterPage.tsx